  <span class="tooltip-sha">SHA256: {{ data }}</span>
  <br />
  <span>Linux: sha256sum [file location]</span>
  <br />
  <span>Windows: certutil -hashfile [file location] SHA256</span>
